const doc = [({"en":({"adminConstantAdminUserRoleType":({"admin":"Admin user", "general":"General user", "onlyProperty":"Read only user"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;